/** 
*@author: Sirisha.M
*@Description : 
**/
import '../CSS/index.css';
import axios from 'axios';
import { connect } from 'react-redux';
import Highlighter from 'react-highlight-words';
import localStorage from '../../../utils/localStorage';
import StyledTable from '../../../commons/styles/table';
import React, { useState, useEffect, useRef } from 'react';
import { API_MODULES, IPAddress } from '../../../commons/api';
import themeSettings from '../../../commons/styles/themeSettings.json';
import {
  Form,
  Input,
  message,
  Tabs,
  Drawer,
  Upload,
  Select,
  Modal,
  Button
} from 'antd';
import {
  UpdateAssetParameter,
  CreateAssetParamMasters,
  // getModulesFileDownloadName,
  getAssetParameterFileDownloadName
} from '../APICalls';
import {
  SearchOutlined,
  EditOutlined,
  UploadOutlined,
  DownloadOutlined,
  PlusOutlined
} from '@ant-design/icons';
import { DrawerFooter } from '../../../commons/styles/layout';
import translation from '../Utils/translation';
// import { useHistory, useLocation } from 'react-router-dom';

const ApiList = {
  CreateModule: `${API_MODULES.ModulesCreate}`,
  UpdateModule: `${API_MODULES.ModulesUpdate}`,
  CreateParameters: `${API_MODULES.AssetParametersCreate}`,
  UpdateParameters: `${API_MODULES.AssetParametersUpdate}`
};

const { TabPane } = Tabs;
const { Option } = Select;

const AssetParameter = (props) => {
  const [formData, setFormData] = useState({});
  // const [presentActiveKey, setPresentActiveKey] = useState('List');
  const [ParameterList, setParameterList] = useState([]);
  const [AssetType, setAssetType] = useState('');
  const [modalVisible, setModalVisible] = useState(false);
  const [visiblePrameter, setVisiblePrameter] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [AssetParameterFileDownloadName, setAssetParameterFileDownloadName] = useState('');
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);

  const pForm = useRef(null);
  // const location = useLocation();
  // const history = useHistory();

  useEffect(() => {
    const searchParams = new URLSearchParams(props && props.location && props.location.search);
    const newParams = Object.fromEntries([...searchParams]);
    const assetType = newParams && newParams.AssetType;
    setAssetType(assetType);
    // DeviceTypeApi();
    _getParameterList(assetType);
    getAssetParametersFileDownloadName(assetType);
  }, [location.search]);

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
  }, [translationCache]);

  const _getParameterList = (AssetType) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const url = `/api/rubusMaster/assetParameters/get?SiteId=${siteId}&AssetType=${AssetType}`;

    const orgHeaders = {
      method: 'GET',
      url,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };

    axios(orgHeaders)
      .then((response) => {
        setParameterList(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const editRecord = (record) => {
    if (pForm.current) {
      pForm.current.setFieldsValue(record);
    }
    setVisiblePrameter(true);
    setFormData(record);
  };



  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            // Access the input element using useRef
            searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8 }}
        >
          {translation(translationCache, 'Search')}
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {translation(translationCache, 'Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible && searchInput) {
        setTimeout(() => searchInput.select());
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      )
  });

  const onParameterFinish = async () => {
    if (pForm.current) {
      try {
        const values = await pForm.current.validateFields();
        const payload = { ...values };

        if (formData && formData.Id) {
          const UpdateResponse = await UpdateAssetParameter(
            ApiList.UpdateParameters,
            payload,
            formData.Id,
            AssetType
          );
          if (UpdateResponse && UpdateResponse.status === 200) {
            message.success(UpdateResponse.data.message);
          }
        } else {
          const CreateResponse = await CreateAssetParamMasters(
            ApiList.CreateParameters,
            payload,
            AssetType
          );
          if (CreateResponse && CreateResponse.status === 200) {
            message.success(CreateResponse.data.message);
          }
        }

        getAssetParametersFileDownloadName(AssetType);
        _getParameterList(AssetType);
        pForm.current.setFieldsValue({
          DeviceType: null,
          Code: null,
          Name: null,
          Type: null,
          Category: null,
          DataType: null,
          UOM: null
        });
        setFormData({});
        setVisiblePrameter(false);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const OpenParametrDrawer = () => {
    if (pForm.current) {
      pForm.current.setFieldsValue({
        DeviceType: null,
        Code: null,
        Name: null,
        Type: null,
        Category: null,
        DataType: null,
        UOM: null
        // AssetType: null
      });
    }

    setFormData({
      DeviceType: null,
      Code: null,
      Name: null,
      Type: null,
      Category: null,
      DataType: null,
      UOM: null
    });
    setVisiblePrameter(true);
  };

  const onParameterClose = () => {
    if (pForm.current) {
      pForm.current.setFieldsValue({
        DeviceType: null,
        Code: null,
        Name: null,
        Type: null,
        Category: null,
        DataType: null,
        UOM: null
        // AssetType: null
      });
    }
    setVisiblePrameter(false);
    setFormData({});
  };

  const getAssetParametersFileDownloadName = async (AssetType) => {
    const assetParameterFileDownloadName = await getAssetParameterFileDownloadName(AssetType);
    setAssetParameterFileDownloadName(
      assetParameterFileDownloadName && assetParameterFileDownloadName.file
        ? assetParameterFileDownloadName.file
        : ''
    );
  };

  let searchInput;

  const handleModalConfirm = () => {
    setModalVisible(false);
  };

  const handleModalCancel = () => {
    setModalVisible(false);
  };

  const ParameterColum = [
    { key: 'S No', value: 'S No' },
    { key: 'Parameter Code', value: 'Code' },
    { key: 'Parameter Name', value: 'Name' },
    { key: 'Type', value: 'Type' },
    { key: 'Category', value: 'Category' },
    { key: 'Data Type', value: 'DataType' },
    { key: 'UOM', value: 'UOM' }
  ];

  const ParametersColumns = Array.isArray(ParameterColum)
    ? ParameterColum.map((field) => ({
      title: field.key,
      dataIndex: field.value,
      key: field.value,
      ...getColumnSearchProps(field.value)
    }))
    : [];

  const ParameterColumns = [
    ...ParametersColumns,
    {
      title: translation(translationCache, 'Actions'),
      dataIndex: 'Actions',
      key: 'Actions',
      render: (_text, record) => (
        <span>
          <Button
            icon={<EditOutlined />}
            onClick={() => editRecord(record)}
            
          />
        </span>
      )
    }
  ];

  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  const Authorization = 'Bearer ' + token;

  return (
    <div style={{ padding: '0px 30px', minHeight: window.innerHeight - 114 }}>
      <Modal
        className="ServerRegistrationModal"
        closable={false}
        title={null}
        open={modalVisible}
        onOk={handleModalConfirm}
        cancelText={translation(translationCache, 'No')}
        okText={translation(translationCache, 'Yes')}
        onCancel={handleModalCancel}
      >
        Are you sure that you want to upload all masters
      </Modal>
      <Tabs tabPosition="top" type="card" style={{ marginBottom: '30px' }} className="Modules">
        <TabPane tab={translation(translationCache, 'Asset Parameters')} key="AssetParameters">
          <div style={{ display: 'flex', justifyContent: 'right', marginTop: '10px' }}>
            <a href={`${IPAddress.LOCAL}${AssetParameterFileDownloadName}`}>
              <DownloadOutlined style={{ color: 'white', marginRight: '1px' }} />
              <span style={{ color: 'white', marginRight: '10px' }}>Download </span>
            </a>
            <Upload
              multiple={false}
              style={{ marginRight: '10px', color: 'white' }}
              onChange={(info) => {
                if (info.file.status === 'done') {
                  message.success(info.file.response.message);
                  getAssetParameterFileDownloadName(AssetType);
                  _getParameterList(AssetType);
                } else if (info.file.status === 'error') {
                  message.error(info.file.response.message);
                }
              }}
              action={`/api/rubusMaster/upload/assetParameters?SiteId=${siteId}&AssetType=${AssetType}`}
              headers={{
                Authorization: Authorization
              }}
              showUploadList={false}
            >
              <UploadOutlined style={{ color: 'white', marginRight: '1px' }} />
              <span style={{ color: 'white', marginRight: '10px' }}> Upload </span>
            </Upload>


            <Button type="primary" onClick={() => OpenParametrDrawer()}>
              <PlusOutlined />
              {translation(translationCache, 'Add')}
            </Button>
          </div>
          <StyledTable size="small"
            columns={ParameterColumns}
            dataSource={ParameterList}
            // scroll={{ x: 1500, y: 450 }}
          />
        </TabPane>
      </Tabs>
      <Drawer
        title={translation(translationCache, "Asset Parameter")}
        width={720}
        onClose={onParameterClose}
        open={visiblePrameter}
        footer={
          <DrawerFooter>
            <Button onClick={onParameterClose} style={{ marginRight: 8 }}>
              {translation(translationCache, 'Cancel')}
            </Button>
            <Button onClick={onParameterFinish} type="primary">
              {translation(translationCache, 'Submit')}
            </Button>
          </DrawerFooter>
        }
      >
        <Form
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 12 }}
          theme={themeSettings}
          layout="horizontal"
          ref={pForm}
          name="Site_form"
          initialValues={formData}
          onFinish={onParameterFinish}>
          <Form.Item
            name="Code"
            label={translation(translationCache, 'Code')}
            rules={[{ required: true, message: 'Please enter Code' }]}
          >
            <Input placeholder="Please enter Parameter Code" maxLength={30} />
          </Form.Item>
          <Form.Item
            name="Name"
            label={translation(translationCache, 'Name')}
            rules={[{ required: true, message: 'Please enter Name' }]}
          >
            <Input placeholder="Please enter Parameter Name" maxLength={255} />
          </Form.Item>
          <Form.Item
            name="Type"
            label={translation(translationCache, 'Type')}
            rules={[{ required: true, message: 'Please enter Type' }]}
          >
            <Input placeholder={translation(translationCache, 'Please enter Type')} />
          </Form.Item>
          <Form.Item
            name="Category"
            label={translation(translationCache, 'Category')}
            rules={[{ required: true, message: 'Please select Category' }]}
          >
            <Select
              placeholder={translation(translationCache, 'Select Category')}
              disabled={formData && formData.Id ? true : false}
            >
              <Option value="Operational">{'Operational'}</Option>
              <Option value="OnChange">{'OnChange'}</Option>
            </Select>

          </Form.Item>
          <Form.Item
            name="DataType"
            label={translation(translationCache, 'DataType')}
            rules={[{ required: true, message: 'Please enter DataType' }]}
          >
            <Input placeholder={translation(translationCache, 'Please enter DataType')} />
          </Form.Item>
          <Form.Item
            name="UOM"
            label={translation(translationCache, 'UOM')}
            rules={[{ required: true, message: 'Please enter UOM' }]}
          >
            <Input placeholder="Please enter Parameter UOM" maxLength={30} />
          </Form.Item>
        </Form>
        <DrawerFooter>
          <Button onClick={onParameterClose} style={{ marginRight: 8 }}>
            {translation(translationCache, 'Cancel')}
          </Button>
          <Button type="primary" onClick={onParameterFinish}>
            {translation(translationCache, 'Submit')}
          </Button>
        </DrawerFooter>
      </Drawer>
    </div>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache

});
export default connect(mapStateToProps)(AssetParameter);
